import React, {
  createContext,
  useReducer,
  useEffect,
  useContext,
  useMemo,
} from 'react';

import { LicenseInfo } from '@mui/x-license-pro';

import Reducer from './AppReducer';
import { initialState } from './index';
import { AppState } from '../@types/State';
const STORAGE_KEY = 'AppState';

LicenseInfo.setLicenseKey(
  'e4871848438f628ddc6a04b5a607c6c9Tz04MzAxMixFPTE3Mzc4OTk3MTgwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI='
);

const parseState = (str: string | null) => {
  return (str ? JSON.parse(str) : {}) as AppState;
};

const persistedState: AppState = {
  ...initialState,
  ...parseState(localStorage.getItem(STORAGE_KEY)),
};

const AppContext = createContext<{
  appState: AppState;
  appDispatch: React.Dispatch<any>;
}>({
  appState: persistedState,
  appDispatch: () => null,
});

interface Props {
  children: React.ReactNode;
}

const AppProvider: React.FC<Props> = ({ children }) => {
  const [appState, appDispatch] = useReducer(Reducer, persistedState);
  const obj = useMemo(() => ({ appState, appDispatch }), [appState]);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(appState));
  }, [appState]);
  return <AppContext.Provider value={obj}>{children}</AppContext.Provider>;
};

export function useAppState() {
  return useContext(AppContext);
}

export { AppContext, AppProvider };
